import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useDevMode() {
  const [isDev, setIsDev] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      const { data: s } = await supabase.auth.getSession();
      if (!s.session) {
        if (!cancelled) { setIsDev(false); setLoading(false); }
        return;
      }
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", s.session.user.id)
        .eq("role", "developer" as any)
        .maybeSingle();
      if (!cancelled) {
        setIsDev(!!data);
        setLoading(false);
      }
    };
    check();
    const { data: sub } = supabase.auth.onAuthStateChange(() => check());
    return () => { cancelled = true; sub.subscription.unsubscribe(); };
  }, []);

  return { isDev, loading };
}
